import { render, staticRenderFns } from "./footerV2.vue?vue&type=template&id=778edd3f&scoped=true"
import script from "./footerV2.vue?vue&type=script&lang=js"
export * from "./footerV2.vue?vue&type=script&lang=js"
import style0 from "./footerV2.vue?vue&type=style&index=0&id=778edd3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778edd3f",
  null
  
)

export default component.exports